import Rules01 from './Rules/Rules01';
import Rules02 from './Rules/Rules02';
import Rules03 from './Rules/Rules03';
import Rules04 from './Rules/Rules04';
import Rules05 from './Rules/Rules05';
import Rules06 from './Rules/Rules06';
import TitleRules from './Rules/TitleRules';

function Agreement() {
    return (
        <div className="relative">
            <TitleRules />
            <div className="flex flex-col items-center justify-center w-full py-10 mt-28">
                <Rules01 />
                <Rules02 />
                <Rules03 />
                <Rules04 />
                <Rules05 />
                <Rules06 />
            </div>
        </div>
    );
}

export default Agreement;
